import { useContext, useEffect } from 'react';
import { LayoutContext } from '../contexts/LayoutContext';
import BatchTablesList from '../components/BatchTables/BatchTablesList';

function BatchTablesPage() {
  const { setIsContentScrollable } = useContext(LayoutContext);

  useEffect(() => {
    setIsContentScrollable(false);
    return () => { setIsContentScrollable(true); };
  }, [setIsContentScrollable]);

  return <BatchTablesList />;
}

export default BatchTablesPage;
